import { NgModule } from '@angular/core';
import { CommonModule, NgOptimizedImage } from '@angular/common';
import { EmptyStateComponent } from './empty-state.component';
import { EmptyStateTextDirective, EmptyStateTitleDirective } from './empty-state.directive';
import { ButtonSpacerDirective } from '../directives/button.directive';
import { MatButtonModule } from '@angular/material/button';
import { RouterLink } from '@angular/router';
import { AnimatedDelayDirective, AnimatedDirective } from '../directives/animated.directive';
import { MatIconModule } from '@angular/material/icon';
import { MatToolbarModule } from '@angular/material/toolbar';

const EMPTY_STATE_DIRECTIVES = [
    EmptyStateComponent,
    EmptyStateTitleDirective,
    EmptyStateTextDirective,
];

@NgModule({
    imports: [
        CommonModule,
        ButtonSpacerDirective,
        MatButtonModule,
        RouterLink,
        AnimatedDirective,
        AnimatedDelayDirective,
        MatIconModule,
        NgOptimizedImage,
        MatToolbarModule,
    ],
    declarations: [
        ...EMPTY_STATE_DIRECTIVES,
    ],
    exports: [
        ...EMPTY_STATE_DIRECTIVES,
    ],
})
export class EmptyStateModule
{
}
